<template>
<app-base-main>
  <template #base-content>
  <app-tabs-message :tabs="tabs" :type="active" :contentStyle="{'height': '100%'}" title="message" @input="changeActive">
    <template #system>
      <message-center-list :id="id" :message-type="tabs[0].id"></message-center-list>
    </template>
    <template #account>
      <message-center-list :id="id" :message-type="tabs[1].id"></message-center-list>
    </template>
    <template #operation>
      <message-center-list :id="id" :message-type="tabs[2].id"></message-center-list>
    </template>
  </app-tabs-message>
  </template>
</app-base-main>
</template>

<script>
  import MessageCenterList from "./message-center-list";
  import AppTabsMessage from "./components/tabs-message"

  export default {
    name: "message-center",
    components: {MessageCenterList, AppTabsMessage},
    watch: {
      $route: {
        immediate: true,
        handler(to) {
          if (to.query.type) {
            this.active = to.query.type;
            if(to.query.id){
              this.id = to.query.id;
            }
          }
        }
      }
    },
    data() {
      return {
        active: null,
        id: null,
        tabs: [
          {id: 'system', text: '系统消息'},
          {id: 'account', text: '账号消息'},
          {id: 'operation', text: '运营消息'},
        ]
      }
    },
    methods:{
      changeActive(value){
        this.active = value;
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .tabs {
    width: auto;
    margin-right: 24px;
  }
  /deep/ .base-content{
    height: 100%;
  }
</style>
